import Vue from "vue"

export const UsesProductProcessApi = Vue.extend({
    props: {
        storageZoneIdentifier: {required: true, type: String},
        location: {required: true, type: Object},
        batchModelType: {required: false, type: String},
        batchModelIdentifier: {required: false, type: String},
        processType: {required: true, type: String},
    },

    computed: {
        postData() {
            switch (this.batchModelType) {
                case 'shipment-batch':
                    return {
                        dispatch_request_batch_identifier: this.batchModelIdentifier.toString(),
                    }
                case 'goods-receipt':
                    return {
                        goods_receipt_identifier: this.batchModelIdentifier.toString(),
                    }
            }

            return {}
        },
    },
})
